<template>
  <div id="app">
    <TripCircuit v-if="branding === 'TripCircuit'" />
    <GantTravel v-else-if="branding === 'Gant Travel'" />
    <router-view v-else />
  </div>
</template>

<script>
import "@/assets/scss/style-default.scss";
import { gantTravelRoutes } from "@/router";
import GantTravel from "@/layouts/GantTravel.vue";
import TripCircuit from "@/layouts/TripCircuit.vue";

export default {
  components: { GantTravel, TripCircuit },
  data() {
    return {
      branding: "TripCircuit",
      brands: {
        gantTravel: "Gant Travel",
        tripCircuit: "TripCircuit",
      },
    };
  },
  watch: {
    $route() {
      this.setBranding();
    },
  },
  created() {
    this.setBranding();
  },
  methods: {
    setBranding() {
      const gantTravelRouteNames = gantTravelRoutes.map((gantTravelRoute) => {
        return gantTravelRoute.name;
      });

      if (gantTravelRouteNames.includes(this.$route.name)) {
        this.branding = this.brands.gantTravel;
      } else {
        this.branding = this.brands.tripCircuit;
      }

      document.title = this.branding;
    },
  },
};
</script>
